import { Type } from "./type";
import { authRepository } from "@/modules/auth/repositories";
import router from "@/routes";
import { useToast } from "vue-toastification";
const toast = useToast();

export const otpModule = {
  namespaced: true,
  state: () => ({
    otp: {
      mobile: null,
      code: null,
      remindTime: 0,
    },
  }),
  getters: {
    remindTime(state) {
      if (state.otp.remindTime < 60)
        return { min: 0, sec: state.otp.remindTime };
      if (state.otp.remindTime == 0) return { min: 0, sec: 0 };
      const MIN = state.otp.remindTime / 60;
      let min = Math.trunc(MIN);
      let sec = (MIN.toFixed(2) - Math.trunc(MIN)) * 100;
      return { min, sec: Math.trunc(sec) };
    },
  },
  mutations: {
    [Type.OTP_GET_CODE_SUCCSESS](state, payload) {
      console.log(payload);
      state.otp = Object.assign({}, payload.result);
      payload.messages.forEach((message) => toast.info(message));
    },
    [Type.OTP_RESET_REMIND_TIME](state) {
      state.otp.remindTime = 0;
    },
    [Type.OTP_VERIFY_SUCCSESS](
      state,
      { messages = [], result: { mobile, code } }
    ) {
      state.otp.mobile = mobile;
      state.otp.code = code;
      messages.forEach((message) => toast.info(message));
      router.push({
        path: "register-confirm",
        query: {
          mobile,
          code,
        },
      });
    },
  },
  actions: {
    async [Type.OTP_GET_CODE]({ commit }, payload) {
      try {
        const { data } = await authRepository.otpGetCode(payload);
        commit(Type.OTP_GET_CODE_SUCCSESS, data?.data);
      } catch (error) {
        console.error(error);
      }
    },
    async [Type.OTP_VERIFY]({ commit }, payload) {
      try {
        const { data } = await authRepository.otpVerify(payload);
        commit(Type.OTP_VERIFY_SUCCSESS, data?.data);
      } catch (error) {
        console.error(error);
      }
    },
  },
};
